import store from '@/store'

export default [
  {
    path: '/holiday-rules',
    name: 'holiday-rule',
    meta: { requiresAuth: true },
    component: () => import('@/pages/holiday-rule/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('holidayRule/dataBeforeCreate')
      next()
    }
  }
]
